import React from 'react';

const PhoneScreenshot = ({ 
  imageSrc, 
  alt = "App Screenshot", 
  theme, 
  className = "",
  showGlow = false,
  showPerspective = false,
  height = "600px",
  fallbackText = "Screenshot not available",
  frameBackground
}) => {
  const styles = {
    phoneFrame: {
      backgroundColor: frameBackground || theme?.neutral?.gray?.[200] || theme?.background?.main || '#111827',
      height: height
    },
    phoneScreen: {
      backgroundColor: theme?.neutral?.white || theme?.background?.input || '#FFFFFF'
    },
    fallbackBackground: {
      backgroundColor: theme?.neutral?.gray?.[200] || theme?.background?.card || '#E5E7EB'
    },
    fallbackText: {
      color: theme?.neutral?.gray?.[500] || theme?.text?.secondary || '#6B7280'
    },
    glowEffect: {
      backgroundColor: theme?.primary?.blue?.[500] || theme?.primary?.blue?.[600] || '#3B82F6'
    }
  };

  const phoneClasses = `
    relative rounded-[3rem] p-2 shadow-2xl
    ${showPerspective ? 'transform perspective-1000 transition-transform duration-300' : ''}
    ${className}
  `.trim();

  const screenClasses = `
    w-full h-full rounded-[2.5rem] overflow-hidden
  `.trim();

  const perspectiveStyle = showPerspective ? {
    transform: 'perspective(1000px) rotateY(-10deg) rotateX(5deg)',
  } : {};

  return (
    <div className="relative flex justify-center">
      <div className="relative" style={perspectiveStyle}>
        {/* Phone Frame */}
        <div 
          className={phoneClasses}
          style={styles.phoneFrame}
        >
          {/* Phone Screen with Screenshot */}
          <div 
            className={screenClasses}
            style={styles.phoneScreen}
          >
            {imageSrc ? (
              <img
                src={imageSrc}
                alt={alt}
                className="w-full h-full object-cover rounded-[2.5rem]"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextElementSibling.style.display = 'flex';
                }}
              />
            ) : null}
            
            {/* Fallback Content */}
            <div 
              className={`absolute inset-0 rounded-[2.5rem] ${imageSrc ? 'hidden' : 'flex'} items-center justify-center flex-col text-center p-6`}
              style={styles.fallbackBackground}
            >
              <div className="text-6xl mb-4 opacity-70">📱</div>
              <div className="text-lg font-semibold" style={styles.fallbackText}>
                {fallbackText}
              </div>
            </div>
          </div>
        </div>

        {/* Glow Effect */}
        {showGlow && (
          <div 
            className="absolute -inset-4 rounded-[4rem] opacity-20 blur-2xl -z-10"
            style={styles.glowEffect}
          />
        )}
      </div>
    </div>
  );
};

export default PhoneScreenshot;
